import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmailRulesServiceProvider } from '../../api/email-rules'

const EmailRulesService = EmailRulesServiceProvider()
const storeName = 'updateEmailRule'

export default ({ id, name, queryParameters }) => (asyncAction(
  storeName,
  EmailRulesService.updateEmailRule,
  { id, name: name, queryParameters }
))

export const reducer = asyncReducer(storeName)
export const selector = asyncSelector(storeName)



// WEBPACK FOOTER //
// ./src/store/email-rules/updateEmailRule.js